import { FunctionalComponent, ComponentChildren, createContext } from 'preact'
import { useContext, useState } from 'preact/hooks'
import { NapiProduct } from '@nespresso/catalog-sdk'

type ProductsContextType = {
    products: NapiProduct[] | undefined
    setProducts: (products: NapiProduct[]) => void
}

const ProductsContext = createContext<ProductsContextType | undefined>(
    undefined
)

export const ProductsProvider: FunctionalComponent = ({
    children
}: {
    children: ComponentChildren
}) => {
    const [products, setProducts] = useState<NapiProduct[]>([])

    const set = p => setProducts(p)

    return (
        <ProductsContext.Provider value={{ products, setProducts: set }}>
            {children}
        </ProductsContext.Provider>
    )
}

export const useProducts = () => {
    const context = useContext(ProductsContext)
    if (!context) {
        throw new Error('useProducts must be used within a ProductsProvider')
    }
    return context
}
